function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { onFieldInit, onFieldMount, onFieldUnmount, onFieldValueChange, onFieldInputValueChange, onFieldInitialValueChange, onFieldValidateStart, onFieldValidateEnd, onFieldValidateFailed, onFieldValidateSuccess, onFieldReact, FormPath } from "@formily/core";
import { untracked } from "@formily/reactive";
import { applyItem, isAttr, popPath } from "../../fieldPath";
export const FieldEffectApiMap = {
  onFieldInit,
  onFieldMount,
  onFieldUnmount,
  onFieldValueChange,
  onFieldInputValueChange,
  onFieldInitialValueChange,
  onFieldValidateStart,
  onFieldValidateEnd,
  onFieldValidateFailed,
  onFieldValidateSuccess,
  onFieldReact
};
export function parsePath(path, basePath) {
  const STAR = ".*";
  const SPECIAL_SYMBOL = ".___EASY_FORMILY_SPECIAL_SYMBOL___";
  if (basePath.includes(STAR)) {
    const absoluteBasePath = basePath.replaceAll(STAR, SPECIAL_SYMBOL);
    const newPath = FormPath.parse(path, absoluteBasePath).toString();
    return newPath.replaceAll(SPECIAL_SYMBOL, STAR);
  }
  return FormPath.parse(path, basePath).toString();
}
export function getStringPath(path, { baseStringPath } = {}) {
  let stringPath = typeof path === "string" ? path : path.refPropsPath();
  if (baseStringPath) {
    stringPath = parsePath(stringPath, baseStringPath);
    stringPath = applyItem(baseStringPath, stringPath);
  }
  return stringPath;
}
export function getFieldByPath(path, form, { baseStringPath }) {
  const stringPath = getStringPath(path, {
    baseStringPath
  });
  const field = form.query(stringPath).take();
  return field;
}
export function attrPathToPath(path) {
  let attribute, pathWithoutAttribute;
  if (typeof path === "string") {
    const [p, attr] = path.split("#");
    attribute = attr;
    pathWithoutAttribute = p;
  } else {
    if (isAttr(path)) {
      attribute = path.refPropsName();
    }
    pathWithoutAttribute = path;
  }
  if (!attribute) {
    attribute = "value";
  }
  return [
    attribute,
    pathWithoutAttribute
  ];
}
export function getDepByPath(path, form, { baseStringPath, isUntracked }) {
  const [attribute, pathWithoutAttribute] = attrPathToPath(path);
  const field = getFieldByPath(pathWithoutAttribute, form, {
    baseStringPath
  });
  if (!field) {
    return void 0;
  }
  if (isUntracked) {
    return untracked(() => field[attribute]);
  }
  return field[attribute];
}
export function getRelativePath(uiPath, dataPath) {
  const noVoidUiPath = uiPath.noVoidPath();
  const { parent } = popPath(noVoidUiPath);
  if (!parent) {
    return dataPath.refPropsPath();
  }
  const prefix = `${parent}.`;
  if (dataPath.refPropsPath().startsWith(prefix)) {
    return dataPath.refPropsPath().slice(prefix.length);
  }
  return;
}
export const MarkupPropToFieldState = {
  title: "title",
  description: "description",
  default: "initialValue",
  readOnly: "readOnly",
  writeOnly: "editable",
  enum: "dataSource",
  // required 需要同时转化为 field 的 validator
  required: (field, value) => {
    field.required = value;
    const { validator } = field;
    if (typeof validator === "undefined") {
      field.validator = [
        {
          required: value
        }
      ];
    } else if (typeof validator === "string" || typeof validator === "function") {
      field.validator = [
        validator,
        {
          required: value
        }
      ];
    } else if (Array.isArray(validator)) {
      let existed = false;
      for (const v of validator) {
        if (typeof v === "object" && Object.hasOwn(v, "required")) {
          v.required = value;
          existed = true;
        }
      }
      if (!existed) {
        field.validator = [
          ...validator,
          {
            required: value
          }
        ];
      }
    } else if (typeof validator === "object") {
      if (Object.hasOwn(validator, "required")) {
        field.validator = _object_spread_props(_object_spread({}, validator), {
          required: value
        });
      } else {
        field.validator = [
          validator,
          {
            required: value
          }
        ];
      }
    }
  },
  "x-pattern": "pattern",
  "x-display": "display",
  "x-validator": "validator",
  "x-decorator": "decorator",
  "x-decorator-props": "decoratorProps",
  "x-component": "component",
  "x-component-props": "componentProps",
  "x-content": "content",
  "x-visible": "visible",
  "x-hidden": "hidden",
  "x-disabled": "disabled",
  "x-editable": "editable",
  "x-read-only": "readOnly",
  "x-read-pretty": "readPretty",
  "x-data": "data",
  "x-value": "value",
  "c-value": "value"
};
